var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"panel",staticClass:"panel",style:(_vm.isFixed ? _vm.fixedStyle : null)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }